<div *ngIf="transportOrder" class="row mb-3">
  <div class="col-12 col-md-6 mb-3 mb-md-0">
    <jhi-bary-card titleKey="TRANSPORT_ACTIONS.TITLE">
      <div body>
        <jhi-bary-button
          *ngIf="isDeletable && !isDeliveryStatusCanceled(transportOrder.deliveryStatus)"
          color="danger"
          size="sm"
          (clickEvent)="deleteTransport()"
          [label]="'BTN.CANCEL' | translate"
          class="waves-light"
        ></jhi-bary-button>
        <jhi-bary-button *ngIf="ediId" color="main" size="sm" (clickEvent)="sendEdi()" [label]="'BTN.RESEND_EDI' | translate" class="waves-light"></jhi-bary-button>
        <ng-container *ngIf="isDisabledButtonModify() || this.isQuotation; else other">
          <jhi-bary-button
            [disabled]="true"
            [tooltip]="this.tooltip"
            icon="circle-info"
            color="primary"
            size="sm"
            [label]="'BTN.UPDATE' | translate"
            class="waves-light"
          ></jhi-bary-button>
        </ng-container>
        <ng-template #other>
          <jhi-bary-button icon="pencil" color="primary" size="sm" [label]="'BTN.UPDATE' | translate" (clickEvent)="goToUpdateTransport()" class="waves-light"></jhi-bary-button>
        </ng-template>

        <jhi-bary-button
          *ngIf="transportOrder.deliveryStatus != 'DELIVERED'"
          icon="clipboard-check"
          color="success"
          size="sm"
          [label]="'BTN.CONFIRM_DELIVERY' | translate"
          class="waves-light"
          (clickEvent)="confirmDelivery()"
        ></jhi-bary-button>
      </div>
    </jhi-bary-card>
  </div>
  <div class="col-12 col-md-6 mb-md-0">
    <jhi-transport-edi-history [transportOrderId]="transportOrder.id"></jhi-transport-edi-history>
  </div>
</div>
